import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { modal } from 'redux/modules/app'
import { form } from 'helpers/decorators'
import { mapLeaders } from '../../../../helpers/mapForSelect'
import { SelectOption } from '../../../../components/misc'
import { apiOrganizations } from '../../../../helpers/decorators/api'
import { FormattedMessage } from 'react-intl'
import { validateUnassignedParticipants } from '../../../../models/tasks'
import styles from './assign-award-leader.styl'


const enhance = compose(
    apiOrganizations(),
    connect(({ api }) => ({
        leaders: api.organizations.leaders,
        loading: api.organizations.leaders.loading
    }), { modal }),
    form({
        form: 'assign-award-leader-form',
        validate: validateUnassignedParticipants,
        disableHook: true
    })
)

class AssignAwardLeader extends Component {
    static propTypes = {
        assignLeader: PropTypes.func.isRequired,
        handleSubmit: PropTypes.func.isRequired,
        awardId: PropTypes.number.isRequired,
        user: PropTypes.object.isRequired,
        intl: PropTypes.object.isRequired,
        orgId: PropTypes.number.isRequired,
        onGetOrganizationContacts: PropTypes.func.isRequired,
        leaders: PropTypes.array,
        modal: PropTypes.func.isRequired,
        loading: PropTypes.bool
    }

    componentDidMount = async() => {
        const { orgId } = this.props

        orgId && await this.props.onGetOrganizationContacts(orgId)
    }

    handleAssignAwardLeader = fields => {
        const { assignLeader, awardId } = this.props

        assignLeader(awardId, fields)
        this.props.modal(null)
    }

    render(){
        const {
            user,
            intl,
            leaders,
            awardId,
            handleSubmit,
            loading
        } = this.props

        const options = mapLeaders(leaders, user, intl, false)

        return (
            <div>
                <h2 className="text--center">
                    <FormattedMessage
                        id="label.assign_award_leader"
                        defaultMessage="Assign Award Leader"
                    />
                </h2>
                <div className={styles.formWrapper}>
                <form
                    loading={loading}
                    onSubmit={handleSubmit(fields => this.handleAssignAwardLeader(fields))}
                >
                    <SelectOption options={options} id={awardId} values={this.props.values} />
                </form>
                </div>
            </div>
        )
    }
}

export default enhance(AssignAwardLeader)
